import React, { forwardRef, InputHTMLAttributes } from 'react'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
    label: string
    text?: string
}

const ChecBox = forwardRef<HTMLInputElement, InputProps>(
    ({ label, text, ...rest }, ref) => {
        return (
            <label className="custom-checkbox w-full">
                <input {...rest} ref={ref} className="custom-checkbox__input" />
                <span className="custom-checkbox__input-fake">
                    <span className="icon-ico-check"></span>
                </span>
                <div className="custom-checkbox__label">
                    <span>{label}</span>
                    {text && (
                        <span className="custom-checkbox__help-text">
                            {text}
                        </span>
                    )}
                </div>
            </label>
        )
    },
)

export default ChecBox
